export const countFeaturedComparables = (comparableListings, comparableSales) => {
  const listingsCount = comparableListings.featured.filter(id => comparableListings.selected.includes(id)).length;
  const salesCount = comparableSales.featured.filter(id => comparableSales.selected.includes(id)).length;
  return listingsCount + salesCount;
};